import { render, staticRenderFns } from "./ValueOfGoodsHSCodeHelp.vue?vue&type=template&id=67b22bf4"
import script from "./ValueOfGoodsHSCodeHelp.vue?vue&type=script&lang=js"
export * from "./ValueOfGoodsHSCodeHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports